module.exports = __webpack_public_path__ + "img/1 (129).4d01f6c7.png";